/* eslint-disable i18next/no-literal-string */
import Header from "~/components/header/Header";
import Footer from "~/components/home/Footer";
import {
  LandingPageHeaderH2,
  LandingPageSubheader,
} from "~/components/landing/LandingText";
import FamilyHero from "~/components/connecting-family/FamilyHero";
import EasyInstallation, {
  EasyInstallationSubText,
} from "~/components/landing/EasyInstallation";
import Pricing from "~/components/landing/Pricing";
import HighlightsGrid from "~/components/connecting-family/HighlightsGrid";
import AllFeatures from "~/components/landing/AllFeatures";
import PrivacyPromised from "~/components/landing/PrivacyPromised";
import ObdCompatibility from "~/components/landing/ObdCompatibility";
import FeaturedQuote from "~/components/connecting-family/FeaturedQuote";
import Reviews from "~/components/landing/Reviews";
import Ratings from "~/components/landing/Ratings";
import DeviceFeatures from "~/components/landing/DeviceFeatures";
import MiscGrid from "~/components/connecting-family/MiscGrid";
import FamilyMarketingVideos from "~/components/connecting-family/FamilyMarketingVideos";

// Ported from bouncieweb's `pages/connecting-family.js` -> `components/LandingFamily.js`
// (rendered there with `footerLite` and canonicalUrl 'https://www.bouncie.com/family').
// Faithful reproduction: same section order, copy, and layout as the original.
export default function ConnectingFamily() {
  return (
    <>
      {/* React 19 hoists these into the document <head> (no wrapper element —
          a nested <head> collides with root.tsx's document head). */}
      <title>GPS Tracker for Families &amp; Teen Drivers | Bouncie</title>
      <meta
        name="description"
        content="Help protect teen and family drivers with real-time GPS tracking, driving alerts, and location history using the Bouncie mobile app."
      />
      <link rel="canonical" href="https://www.bouncie.com/family" />

      <Header />

      {/* LandingPageGlobalStyles: color fadedBlack2 + balanced text wrap */}
      <div className="[text-wrap:balance] text-[#0B1019]">
        <FamilyHero />

        {/* eslint-disable-next-line local/no-wrap-legacy -- legacy port, not yet redesigned */}
        <div className="wrap-legacy">
          <EasyInstallation
            preHeading={<>Yes, it&rsquo;ll work in your car!</>}
            heading={
              <>
                <EasyInstallationSubText>No tools.</EasyInstallationSubText>
                <EasyInstallationSubText>No wires.</EasyInstallationSubText>
                <EasyInstallationSubText>
                  It just plugs in.
                </EasyInstallationSubText>
              </>
            }
          />
          <Pricing />
          <LandingPageHeaderH2>Your connected driving app.</LandingPageHeaderH2>
          <LandingPageSubheader>
            Helping protect what matters most.
          </LandingPageSubheader>
          <HighlightsGrid />
        </div>

        <AllFeatures />

        {/* eslint-disable-next-line local/no-wrap-legacy -- legacy port, not yet redesigned */}
        <div className="wrap-legacy">
          <PrivacyPromised />
          <div id="obd-compatibility-scroll-target" />
          <ObdCompatibility />
          <FeaturedQuote
            quoteText={
              <>
                There&rsquo;s trust, but I<br />
                just want to know
                <br />
                they&rsquo;re safe.
              </>
            }
            imageAlt="Parent and child looking at phone together"
            closeQuoteLeft="6.3em"
            addendum={
              <>
                <p>Should I tell my teen about Bouncie?</p>
                <a
                  className="hover:no-underline min-[431px]:hidden"
                  href="https://www.bouncie.com/blog/parents-guide-to-bouncie-helping-teen-drivers-build-safer-habits"
                >
                  View article &rsaquo;
                </a>
                <a
                  className="hidden hover:no-underline min-[431px]:block"
                  target="_blank"
                  rel="noreferrer"
                  href="https://www.bouncie.com/blog/parents-guide-to-bouncie-helping-teen-drivers-build-safer-habits"
                >
                  View article &rsaquo;
                </a>
              </>
            }
          />
          <Reviews
            carAndDriverImageAlt="Two women on a journey in a car"
            forbesImageAlt="A family at the beach sitting together in the back of their vehicle"
          />
          <Ratings />
          <DeviceFeatures />
          <LandingPageHeaderH2 className="mt-0 mb-8">
            At your fingertips!
          </LandingPageHeaderH2>
          <MiscGrid />
          <div className="h-16" />
          <FamilyMarketingVideos />
          <div className="h-16" />
        </div>

        <Footer />
      </div>
    </>
  );
}
